( function( global, $ ) {
    if($('[data-modal]')) {
        $('[data-modal]').magnificPopup({
            type: 'inline'
        });
    }

    if( $('[data-modal-gallery]') ) {
        $('[data-modal-gallery]').each(function() {
            $(this).magnificPopup({
                delegate: 'div.c-slide',
                gallery: { 
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0,1] // Will preload 0 - before current, and 1 after the current image
                },
                image: {
                    titleSrc: 'title'
                },
                mainClass: 'c-slider__modal',
                type: 'image'
            });
        });
    }

    if( $('[data-modal-trigger]') ) {
        $('[data-modal-trigger]').each(function() {
            var family = $(this).data('modalTrigger');
            if($('[data-modal-image='  + family + ']').length > 0) {
                $(this).click(function() {
                    $('[data-modal-image=' + family + ']').magnificPopup({
                        type: 'image',
                        gallery: { 
                            enabled: true,
                            navigateByImgClick: true,
                            preload: [0,1] // Will preload 0 - before current, and 1 after the current image
                        },
                        mainClass: 'c-slider__modal'
                    }).magnificPopup('open');
                });
            } else if($('[data-modal-video=' + family + ']').length > 0) {
                var $modalVideo = $('[data-modal-video=' + family + ']');
                if ($modalVideo) {
                    var videoLink = $modalVideo.data('videoLink');
                    $(this).click(function() {
                        $.magnificPopup.open({
                            items: {
                                src: videoLink,
                                type: 'iframe'
                            }
                        });
                    });
                } 
            }
        });
    }

    if ( $('[data-modal-finishes]') ) {
        $('[data-modal-finishes]').magnificPopup({
            type: 'inline',
            delegate: 'a[data-modal-finishes-target]'
        });
    }

    if($('[data-modal-inline]')) {
        $('[data-modal-inline]').magnificPopup({
            type: 'inline',
            delegate: 'a[data-modal-inline-target]',
            gallery: {
                enabled: true
            },
            mainClass: 'c-slider__modal'
        });
    }

    if ( $('[data-modal-fabrics]') ) {
        $('[data-modal-fabrics]').magnificPopup({
            type: 'inline',
            delegate: 'a[data-modal-fabrics-target]'
        });
    }
}( window.groots, jQuery, require('magnific-popup') ));

